<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('common.issue')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="self-dialog-form"
    width="70%"
  >
    <div v-show="currentStep === 0">
      <h2 class="edm-form-title">
        <span class="edm-form-title--text">{{ $t("parameterTemplate.chooseConfigItem") }}</span>
      </h2>
      <div class="role--table">
        <div class="role--table--head">
          <ul>
            <li class="li_1">
              <div>{{ $t("parameterTemplate.configItem") }}</div>
            </li>
          </ul>
        </div>
        <div class="role--table--body">
          <el-tree
            ref="parameterTreeRef"
            :data="parameterTree"
            :props="defaultProps"
            show-checkbox
            node-key="configKey"
            :expand-on-click-node="false"
            :check-strictly="false"
          ></el-tree>
        </div>
      </div>
    </div>
    <div v-show="currentStep === 1">
      <h2 class="edm-form-title">
        <span class="edm-form-title--text">{{ $t("parameterTemplate.chooseTenant") }}</span>
      </h2>
      <EdmCustomTable
        ref="EdmCustomTable"
        :loading="tableLoading"
        :table-data="tableData"
        :pagination="pagination"
        :checkbox="true"
        row-key="tenantId"
        :reserve-selection="true"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column
          v-for="(cm, index) in tableColumns"
          :key="cm.field"
          :label="cm.name"
          :index="index"
          :width="cm.width"
          :fixed="cm.fixed"
          :min-width="100"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row[cm.field] }}
          </template>
        </el-table-column>
      </EdmCustomTable>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t("public.cancel") }}</el-button>
      <el-button v-if="currentStep === 0" type="primary" @click="nextStep">
        {{ $t("public.next") }}
      </el-button>
      <el-button v-if="currentStep === 1" type="primary" @click="prevStep">
        {{ $t("public.back") }}
      </el-button>
      <el-button v-if="currentStep === 1" type="primary" @click="onSyncParameter">
        {{ $t("common.issue") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import parameterApi from "@/api/parameter-template";
import BusinessApi from "@/api/business";
export default {
  name: "SyncParameter",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    propData: {
      type: Object,
      default() {
        return {};
      },
    },
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formKey: new Date().getTime(),
      defaultProps: {
        children: "paramItemList",
        label: "configName",
      },
      parameterTree: [],
      tableLoading: false,
      tableColumns: [
        {
          name: this.$t("companyCenter.enterpriseName"),
          field: "tenantName",
          width: "100",
          fixed: false,
        },
        {
          name: this.$t("enterprise.socialCreditCode"),
          field: "socialCreditCode",
          width: "auto",
          fixed: false,
        },
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
      },
      currentStep: 0,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  created() {
    this.getParameterTree();
    this.getTenantList();
  },
  methods: {
    getParameterTree() {
      parameterApi.getParamsTemplate().then((res) => {
        if (res.success) {
          this.parameterTree = res.data.map((item) => {
            item.configName = item.belongModuleName;
            item.configKey = item.id;
            (item.paramItemList || []).forEach((paramsItem) => {
              paramsItem.module = item.belongModule;
            });
            return item;
          });
        }
      });
    },
    nextStep() {
      this.currentStep = 1;
    },
    prevStep() {
      this.currentStep = 0;
    },
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getTenantList();
    },
    getTenantList() {
      this.tableLoading = true;
      const params = {
        "orders[0].asc": "false",
        "orders[0].column": "createTime",
        size: this.pagination.pageSize,
        page: this.pagination.pageNum,
      };
      BusinessApi.getList(params).then((res) => {
        this.tableLoading = false;
        const { data } = res;
        const { records = [], total = 0 } = data;
        this.tableData = records;
        this.pagination.total = Number(total);
      });
    },
    onSyncParameter() {
      const checkedNodes = this.$refs.parameterTreeRef.getCheckedNodes();
      if (checkedNodes.length === 0) {
        this.$message.warning(this.$t("parameterTemplate.pleaseChooseConfigItem"));
        return;
      }
      const checkedTenantList = this.$refs.EdmCustomTable.getChecked();
      if (checkedTenantList.length === 0) {
        this.$message.warning(this.$t("parameterTemplate.pleaseChooseTenant"));
      }
      const moduleParameter = {};
      checkedNodes.forEach((item) => {
        if (!item.belongModule) {
          const cloneItem = Object.assign({}, item);
          delete cloneItem.module;
          if (moduleParameter[item.module]) {
            moduleParameter[item.module].push(cloneItem);
          } else {
            moduleParameter[item.module] = [cloneItem];
          }
        }
      });
      const parameterConfigTemplateList = [];
      for (let i = 0; i < this.parameterTree.length; i++) {
        const item = this.parameterTree[i];
        if (moduleParameter[item.belongModule]) {
          parameterConfigTemplateList.push({
            ...item,
            paramItemList: moduleParameter[item.belongModule],
          });
        }
      }
      const data = {
        tenantIds: checkedTenantList.map((o) => o.tenantId),
        parameterConfigTemplateList,
      };
      // 开始提交
      parameterApi.batchSyncTemplate(data).then((res) => {
        if (res.success) {
          this.$message.success(this.$t("parameterTemplate.issueSuccess"));
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color__ccc: #ccc;
ul,
.role--table--head {
  width: 100%;
  min-width: 450px;
  ul {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    border: 1px solid $border-color__ccc;
    height: 40px;
    background-color: #eaedf3;

    font-size: $scim-font-size-base;
    font-weight: 500;
    text-align: left;
    color: $scim-text-color;
    line-height: 40px;

    .li_1 {
      display: flex;
    }
    .checkbox {
      margin-left: $scim-space-row-lg;
      margin-right: 0;
      color: $scim-text-color;
    }

    li:nth-child(1) {
      padding-left: 10px;
      min-width: 200px;
      flex: 1;
    }
    li:nth-child(2) {
      padding-left: 10px;
      border-left: 1px solid $border-color__ccc;
      width: 206px;
    }
  }
}
.custom-tree-node {
  flex: 1;
  min-width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  span:nth-child(2) {
    display: inline-block;
    width: 200px;
    height: calc(100% + 2px);
    line-height: 40px;
    border-left: 1px solid $border-color__ccc;
    padding-left: 10px;
    text-align: left;
  }
}
::v-deep .el-tree .el-tree-node__content {
  position: relative;
  width: 100%;
  min-width: 420px;
  line-height: 28px;
  height: 36px;
  border: 1px solid $border-color__ccc;
  border-top: none;
}

::v-deep .el-tree .el-tree-node > .el-tree-node__children {
  overflow: inherit;
}
::v-deep .el-tree .el-tree__empty-block {
  border: 1px solid $border-color__ccc;
  border-top: none;
}
//固定表头
.el-tree {
  width: 100%;
  min-width: 450px;
  display: inline-block;
  overflow: auto;
  height: 500px;
}
.el-tag {
  height: 24px;
  line-height: 24px;
}
.el-select {
  width: 100%;
}
.edm-form-title {
  display: flex;
  padding-bottom: 16px;
  font-size: 18px;
  line-height: 18px;
  justify-content: space-between;

  .edm-form-title--text {
    font-weight: 500;

    &::before {
      display: inline-block;
      width: 3px;
      height: 18px;
      margin-right: 8px;
      vertical-align: middle;
      background: #00b259;
      content: "";
      opacity: 1;
    }
  }
}
</style>
